var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 13,
    viewBox: "0 0 14 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9958 5.16912C12.9517 5.03283 12.8343 4.93351 12.6929 4.91293L8.72267 4.33414L6.94706 0.724947C6.88387 0.596466 6.75343 0.515137 6.61062 0.515137C6.46779 0.515137 6.33737 0.596466 6.27416 0.724947L4.49848 4.33414L0.528281 4.91293C0.386978 4.93351 0.269538 5.03283 0.225413 5.16909C0.181264 5.30538 0.218084 5.45496 0.320366 5.55496L3.19316 8.36433L2.51508 12.3313C2.49092 12.4725 2.5488 12.6152 2.66434 12.6994C2.7297 12.747 2.80712 12.7713 2.88491 12.7713C2.94464 12.7713 3.00458 12.757 3.05946 12.728L6.6106 10.8551L10.1616 12.728C10.288 12.7947 10.4412 12.7836 10.5567 12.6994C10.6723 12.6152 10.7302 12.4724 10.706 12.3312L10.0277 8.36433L12.9009 5.55494C13.0031 5.45496 13.04 5.30538 12.9958 5.16912Z",
    fill: "#C6C6C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.eb5889f2e71d41ab994bf085b2ec8774.svg";
export { ForwardRef as ReactComponent };